import { createAsyncThunk } from '@reduxjs/toolkit';

import { entitiesActions } from '../slices/entitiesSlice';
import type { RootState } from '../store';

import { eventsService } from './_deps';

export const inviteToEvent = createAsyncThunk<
  void,
  { eventId: string; telegramIds: number[] },
  { state: RootState }
>('events/invite', async ({ eventId, telegramIds }, thunkApi) => {
  const { dispatch, getState } = thunkApi;

  try {
    const event = await eventsService.inviteToEvent({
      eventId,
      telegramIds,
    });
    dispatch(entitiesActions.upsertEvent(event));
  } catch (error) {
    const message = error instanceof Error ? error.message : 'Не удалось пригласить участников';
    throw error;
  }
});

export const inviteGroupToEvent = createAsyncThunk<
  void,
  { eventId: string; groupId: string },
  { state: RootState }
>('events/inviteGroup', async ({ eventId, groupId }, thunkApi) => {
  const { dispatch, getState } = thunkApi;

  try {
    const event = await eventsService.inviteGroupToEvent({
      eventId,
      groupId,
    });
    dispatch(entitiesActions.upsertEvent(event));
  } catch (error) {
    const message = error instanceof Error ? error.message : 'Не удалось пригласить отряд';
    throw error;
  }
});
